
export default {
    namespaced: true,
    state: {
        phone: null,
        email: null,
        firstName: null,
        lastName: null,
        address_id: null,
        has_info: false,
        has_card: false,
        card: null,
    },
    getters: {

    },
    mutations: {
        SET_DATA_CARD(state, payload) {
            state.card = payload;
        },
        SET_HAS_CARD(state, payload) {
            state.has_card = !!payload;
        },
        SET_HAS_INFORMATION(state, payload) {
            state.has_info = !!payload;
        },
        SET_DATA_ADDRESS(state, payload) {
            state.address_id = payload;
        },
        SET_DATA_INFOS(state, payload) {
            if (!payload) {
                state.phone = null;
                state.email = null;
                state.firstName = null;
                state.lastName = null;
            }
            state.phone = payload.phone;
            state.email = payload.email;
            state.firstName = payload.firstName;
            state.lastName = payload.lastName;
        },
        SET_ADDRESS_ID(state, payload) {
            state.address_id = payload;
        },
        RESET(state) {
            state.phone = null;
            state.email = null;
            state.firstName = null;
            state.lastName = null;
            state.address_id = null;
            state.has_card = false;
            state.has_info = false;
            state.card = null;
        }
    },
    actions: {
        async reset(context) {
            context.commit('RESET')
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/shopping-cart/booking-personal.store.js